export default __webpack_public_path__ + "media/images/icons/tachometer-alt-solid-3f5b871e33c37c9ca0ed41bbd5541161.svg";